'use client';

import { Modale } from '@/app/components/modale/Modale';
import { useModale } from '@/app/hooks/useModale';
import { IActionsButton } from '@/types/spots/actionsButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ActionButton: React.FC<IActionsButton> = ({
  icon,
  text,
  className,
}): React.JSX.Element => {
  const { isModaleVisible, openModale, closeModale } = useModale();

  return (
    <>
      <button
        className={`mr-4 p-2 text-white rounded-lg flex items-center font-primary ${className}`}
        onClick={openModale}
      >
        <FontAwesomeIcon icon={icon} className="mr-2 size-[17px]" />
        {text}
      </button>

      {isModaleVisible && <Modale closeModale={closeModale}></Modale>}
    </>
  );
};
